var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11379_1728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#6AD699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9941 26.2344L11.8164 19.6602V32.7227C11.8182 33.3849 12.0821 34.0195 12.5503 34.4877C13.0186 34.956 13.6532 35.2199 14.3154 35.2217H35.6846C36.3468 35.2199 36.9814 34.956 37.4497 34.4877C37.9179 34.0195 38.1818 33.3849 38.1836 32.7227V19.7979L24.9941 26.2344Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0059 23.7656L38.1836 17.334V17.2773C38.1818 16.6151 37.9179 15.9805 37.4497 15.5123C36.9814 15.044 36.3468 14.7801 35.6846 14.7783H14.3154C13.6684 14.7796 13.047 15.0311 12.5812 15.4801C12.1154 15.9292 11.8414 16.541 11.8164 17.1875L25.0059 23.7656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11379_1728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b05f598db502fb06614488dc87fe44f3.svg";
export { ForwardRef as ReactComponent };